// extracted by mini-css-extract-plugin
export default {"item":"_2431f8da","link":"_c2f0186f","title":"_b5477ccf","imageContainer":"_aec7f70f","image":"_5467ae8","cta":"_f856a339","shimmerLoadingBackground":"_c5279d62"};